/** @format */

import axios from 'axios'
// import jwt_decode from "jwt-decode";

import { endOfMonth, startOfMonth, subDays, subMonths } from 'date-fns'
import { formatDate } from '../helpers/UtilityHelper'
export const apiConstants = {
  BASE_LOCAL: process.env.REACT_APP_API_ENDPOINT,
  // BASE_LOCAL: 'https://proship.prozo.com/api/',
  //  BASE_LOCAL: 'http://localhost:8099/api/',
  AUTH: 'auth/signin',
  AUTH_MY_MERCHANTS: 'auth/my-merchants',
  GOOGLE_SIGNIN: 'auth/signin/google/url',
  // Revokes the presented JWT server-side and drops the refresh session (CWE-613).
  LOGOUT: 'auth/logout',
  DASHBOARD_ORDER_SUMMARY: 'aggregate/orders/',
  ORDER_DETAILS: 'order/getOrder',
  ORDER_LISTS: 'order/search',
  // D2C Courier Performance — backend clubs CT freightsnapshot data by proship service type.
  D2C_COURIER_PERFORMANCE: 'dashboard/d2c-courier-performance',
  B2B_ODA_CHECK: 'order/serviceability/b2b/oda',
  B2B_PTL_ALLOWED_COURIERS: 'b2b/serviceability/ptl-allowed',
  MANIFEST_LISTS: 'manifest/search',
  ORDER_LISTS_CACHED: 'order/searchCached',
  CHANNEL_ORDER_SEARCh: 'channel/order/search',
  ARCHIVE_CHANNEL_ORDERS: 'channel/order/archive',
  ARCHIVED_CHANNEL_ORDER_SEARCH: 'channel/order/archived/search',
  TRACK_BULK_UPLOAD_LISTS: 'order/track_uploaded_orders',
  // v2 bulk-tracking endpoint: returns the enriched MIS payload (correct courier account
  // codes + the full set of drop/pickup/OTP/QC fields the admin panel already consumes).
  TRACK_BULK_UPLOAD_LISTS_V2: 'order/track_uploaded_ordersv2',
  TRACK_ORDER: 'order/track_waybill',
  SERVICEABILITY_PINCODE: 'tools/serviceability',
  SERVICEABILITY_TRENDS_OVERVIEW: 'order/serviceability/intel/trends/overview',
  SERVICEABILITY_COVERAGE_DELIVERY: 'order/serviceability/intel/coverage/delivery',
  SERVICEABILITY_TRENDS_CUTS: 'order/serviceability/intel/trends/cuts',
  // Merchant serviceability coverage (allocation vs. Prozo, by zone) — Phase 1.
  SERVICEABILITY_MERCHANT_COVERAGE_ZONES: 'order/serviceability/merchant/coverage/zones',
  SERVICEABILITY_MERCHANT_COVERAGE_ZONES_CSV: 'order/serviceability/merchant/coverage/zones/download',
  SERVICEABILITY_MERCHANT_COVERAGE_PINCODES_CSV: 'order/serviceability/merchant/coverage/pincodes/download',
  SERVICEABILITY_MERCHANT_SERVICE_TYPES: 'order/serviceability/merchant/service-types',
  SERVICEABILITY_MERCHANT_COVERAGE_MODES: 'order/serviceability/merchant/coverage/modes',
  WEIGHT_FREEZE_LIST: 'system/default/sku',
  WEIGHT_FREEZE_UPLOAD: 'system/default/uploadWeightFreeze',
  WEIGHT_FREEZE_DOWNLOAD: 'system/default/getWeightFreeze',
  FORGOT_PASSWORD: 'auth/reset_password',
  FORGOT_PASSWORD_V2: 'auth/reset_password_v2',
  RESET_PASSWORD: 'auth/set_password',
  SYNC_ORDER: 'order/refreshWaybillStatus',
  PTL_SYNC_ORDER: 'system/track/sync',
  COURIER_LIST: 'courierPartner/search',
  COURIER_LIST_CACHED: 'courierPartner/searchCached',
  SIGNUP: 'merchant/create',
  SIGNUP_UPDATE_NO_ORDERS: 'merchant/update_no_orders',
  DOWNLOAD_ALL_ORDER: 'report/orders',
  GET_MERCHANT: 'merchant',
  GET_MERCHANT_SEARCH: 'merchant/search',
  MERCHANT_SEARCH_CACHED: 'merchant/searchCached',
  MERCHANT_SIGN_IN_CONFIRMATION: 'merchant/sign_in_confirmation',
  UPDATE_MERCHANT: 'merchant/update_bankDetails',
  ADD_LOCATION: 'merchant/register_pickup',
  DOWNLOAD_SAMPLE_LOCATION: 'order/Download_samples',
  NDR_BULK_UPLOAD: 'ndr/bulkAction',
  NPR_BULK_UPLOAD: 'npr/bulkAction',
  NPR_BULK_UPLOAD_V2: 'npr/newBulkAction',
  REASON_MASTER: 'reason-master',
  MARK_RTO_REQUESTED: 'order/markRtoRequested',
  MARK_RTO_REQUESTED_BULK: 'order/markRtoRequested/bulk',
  MARK_RTO_REQUESTED_BULK_STATUS: 'order/markRtoRequested/bulk/status',
  MARK_RTO_RECEIVED: 'order/markRtoReceived',
  UPLOAD_LOCATION: 'merchant/upload_pickup_locations',
  UPLOAD_MERCHANT_LOGO: 'merchant/uploadlogo',
  CREATE_USER: 'auth/user_signup',
  CREATE_API_USER: 'auth/api_user_signup',
  NDR_LISTS: 'order/search',
  NPR_LISTS: 'npr/search',
  CANCEL_ORDER: 'order/cancel_order',
  BULK_UPLOAD_ORDER: 'order/upload_orders',
  B2B_ORDER_FETCH_LABEL: 'order/async/b2b/fetch_label',
  BULK_MERCHANT_SERVICEABILITY: 'tools/serviceability_bulk',
  GET_MERCHANT_USERS: 'auth/users',
  DOWNLOAD_NDR: 'order/downloadNdrReport',
  NDR_ACTION: 'order/ndrActionUpdate',
  GET_ALL_WALLET: 'wallet/merchantWallet',
  GET_WALLET_HISTORY: 'wallet/history',
  GET_WALLET_AUDIT: 'wallet/audit',
  // AGGREGATES NDR
  AGGREGATE_NDR_REASON: 'aggregate/ndr_orders/NDR_REASON/',
  AGGREGATE_NDR_DELIVERY_PINCODE: 'aggregate/ndr_orders/DELIVERY_PINCODE/',
  AGGREGATE_NDR_STATUS: 'aggregate/ndr_orders/NDR_STATUS/',
  AGGREGATE_PAYMENT_MODE: 'aggregate/ndr_orders/PAYMENT_MODE/',
  AGGREGATE_NDR_AGE: 'aggregate/ndr_orders/NDR_AGE/',
  AGGREGATE_NDR_OFD_COUNT: 'aggregate/ndr_orders/NDR_OFD_COUNT/',
  AGG_ORDERS_DAY_WISE_COURIER: 'aggregate/orders/DAYWISE_COURIER/',
  AGG_RTO_ORDERS_BY_STATUS: 'aggregate/rto_orders/ORDER_STATUS/',
  AGG_RTO_ORDERS_BY_CITY: 'aggregate/rto_orders/CITY/',
  AGG_RTO_ORDERS_BY_PINCODES: 'aggregate/rto_orders/DELIVERY_PINCODE/',
  AGG_ORDER_ITEM_WEIGHT: 'aggregate/orders/ITEM_WEIGHT/',
  AGG_ORDER_BY_STATE: 'aggregate/orders/STATE/',
  AGG_ORDER_BY_PAYMENT_MODE: 'aggregate/orders/PAYMENT/',
  AGG_ORDER_BY_PICKUP_PINCODE: 'aggregate/orders/PICKUP_PINCODE/',
  AGG_ORDER_BY_STATUS: 'aggregate/orders/STATUS/',
  AGG_RTO_BY_COURIER: 'aggregate/rto_orders/COURIER/',
  //Wallet payment
  ADD_WALLET_BALANCE: 'wallet/addbalance',
  VERIFY_PAYMENT: 'wallet/verifypayment',
  //Change password
  CHANGE_PASSWORD: 'auth/change_password',
  AGG_ORDER_BY_STATUS_CUSTOM: 'aggregate/orders/custom/STATUS_RANGE/',
  SHIPMENT_RATE_CALCULATOR: 'tools/list/pricing',
  MERCHANT_ACTIVE_SLA: 'tools/activesla',
  COURIERS: 'courierPartner',
  LIST_MODULES: 'auth/listmodules',
  UPDATE_USER_ROLE: 'auth/update_role',
  UPDATE_USER_ACTION: 'auth/accountAction',
  AGG_ORDER_ZONE: 'aggregate/orders/ZONE/',
  REPORT_GENERIC_SEARCH: 'tools/generic/search',
  NDR_RECORDING_SEARCH: 'ndr/recording/search',
  NPR_RECORDING_SEARCH: 'npr/recording/search',
  CONFIG_SEARCH: 'config/search',
  //Notification
  POST_SUBSCRIPTION: 'merchant/subscription',
  GET_SUBSCRIPTION: 'merchant/merchant_notifications',
  POST_SUBSCRIPTION_B2B: 'merchant/subscription/b2b',
  POST_SUBSCRIPTION_RVP: 'merchant/subscription/rvp',
  GET_SUBSCRIPTION_B2B: 'merchant/merchant_notifications_b2b',
  GET_SUBSCRIPTION_RVP: 'merchant/merchant_notifications_rvp',
  //Get User Profile
  GET_USER: 'auth/search',
  UPLOAD_PROFILE_PIC: 'merchant/user/uploadPic/',
  //Wallet Transactions
  ORDER_TRANSACTION: 'wallet/gettransactionsfororders',
  OTHER_TRANSACTION: 'wallet/gettransactionsnonorder',
  //Download Reports
  DOWNLOAD_REPORT: 'reports/get',
  CREATE_ORDER: 'order/create',
  ASYNC_B2B_CREATE_ORDER: 'async/b2b/order/create',
  PICKUP_B2B_CREATE_ORDER: 'b2b/pickup/create',
  BULK_CREATE_ORDER: 'order/Bulk_order_create',
  BULK_CREATE_ORDER_v2: 'order/v2/bulk_order_create_B2C',
  BULK_CREATE_ORDER_B2B: 'async/b2b/order/Bulk_order_create',
  BULK_ORDER_UPLOAD: 'order/bulk_order_upload',
  GET_BULK_UPLOAD_ORDER: 'order/get_bulkOrder_result',
  GET_BULK_UPLOAD_NDR: 'ndr/bulkActionStatus',
  GET_BULK_UPLOAD_NPR: 'npr/bulkActionStatus',
  BULK_DOWNLOAD_LABELS: 'tools/getBulkLabelsAndPdfZip',
  BULK_DOWNLOAD_POD: 'tools/getBulkPodsAndPdfZip',
  GET_ALL_REPORT_TYPES: 'reports/types',
  GET_REPORT_TYPE_DETAILS: 'reports/types/details',
  GET_ALL_GENERATED_REPORTS: 'reports/get/merchant',
  CREATE_REPORT_ASYNC: 'reports/getAsync',
  CREATE_SELECTOR: 'selector/create',
  CREATE_SELECTOR_BULK: 'selector/bulk_create',
  GET_SKU_DIM: 'product/get/all',
  UPLOADS_REMARKS: 'remarks/upload',
  REMARKS: 'remarks/get',
  SAVE_REMRKS: 'remarks/save',
  TAC: 'merchant/acceptMerchantTAC',
  VERIFY_OTP: 'merchant/verify_otp',
  VERIFY_MFA_OTP: 'auth/verify_mfa_otp',
  VERIFY_OTP_RESET_PASSWORD: 'auth/reset_password_v2_verify_otp',
  GENERATE_OTP: 'merchant/generate_otp',
  ADD_MANDATORY: 'merchant/addMandatoryFields',
  GET_WEIGHT_DICREPENACY: 'tools/weight_discrepancy/filter',
  WEIGHT_DISCREPANCY_UPDATE: 'tools/weight_discrepancy/update',
  IMAGE_UPLOAD_WEIGHT_DISCREPANCY: 'tools/wd/submit_images',
  WEIGHT_DISCREPANCY_LINK_UPLOAD: 'tools/wd/submit_image_links',
  // Weight Disputes v2 (merchant panel) — see components/weight/disputes-v2/data/api.js.
  // Detail/accept/dispute/evidence hang off WD_V2_BASE + '/{id}/...'.
  WD_V2_LIST: 'v2/wd/list',
  WD_V2_BASE: 'v2/wd',
  // Merchant Weight Freeze requests (freeze-v2, live sections: Requests & statuses, Raise a request).
  // /{id}/evidence|submit|withdraw|accept-proposal|decline-proposal hang off WF_V2_REQUESTS; WF_V2_BASE + '/category-report'.
  WF_V2_REQUESTS: 'v2/wf/requests',
  WF_V2_BASE: 'v2/wf',
  FETCH_CUSTOM_LABEL: 'order/async/b2b/fetch_label',
  FETCH_ZONE_MAPPING: 'tools/fetchZoneMap',
  CONTROL_TOWER_PICKUP_PENDING:
    'external/ct/controltower/v1/wms/freightsnapshot/all_pickup_pending_orders_grouped_by_mechant',
  CONTROL_TOWER_DELIVERY_PENDING:
    'external/ct/controltower/v1/wms/freightsnapshot/all_delivery_pending_orders_grouped_by_mechant',
  CONTROL_TOWER_PICKED_UP:
    'external/ct/controltower/v1/wms/freightsnapshot/all_pickedup_orders_today_grouped_by_mechant',
  CONTROL_TOWER_RTO_PENDING:
    'external/ct/controltower/v1/wms/freightsnapshot/all_rto_delivery_pending_orders_grouped_by_mechant',
  CONTROL_TOWER_LOST:
    'external/ct/controltower/v1/wms/freightsnapshot/bydate/all_lost_damaged_orders_today_grouped_by_mechant',
  RATE_CARD: 'merchant',
  CREATE_REVERSE_ORDER: 'order/createReverseWithReference',
  ALL_AWB_REGISTERED_BY_DATE_RANGE:
    'external/ct/controltower/v1/wms/freightsnapshot/bydate/all_awb_registered_orders_today_grouped_by_mechant',
  ALL_DELIVERED_BY_DATE_RANGE:
    'external/ct/controltower/v1/wms/freightsnapshot/bydate/all_delivered_orders_today_grouped_by_mechant',
  ALL_RTO_DELIVERED_BY_DATE_RANGE:
    'external/ct/controltower/v1/wms/freightsnapshot/bydate/all_rto_delivered_orders_today_grouped_by_mechant',
  ALL_INTRANSIT_ORDERS:
    'external/ct/controltower/v1/wms/freightsnapshot/all_delivery_pending_orders_grouped_by_mechant',
  ALL_NOT_PICKED_ORDERS:
    'external/ct/controltower/v1/wms/freightsnapshot/all_pickup_pending_orders_grouped_by_mechant',
  SEARCH_INVOICE: 'finance/orderInvoice/filter',
  WEBHOOK_SEARCH: 'merchant/webHooks/',
  WEBHOOK: 'merchant/webHookUpdate',
  GET_REPORT_CONFIG: 'reports/config/get',
  UPDATE_REPORT_CONFIG: 'reports/config/update',
  CREATE_REPORT_CONFIG: 'reports/config/add',
  GENERATE_MANIFEST: 'manifest/generate',
  GENERATE_GROUPED_MANIFEST: 'manifest/generateGrouped',
  GENERATE_BULK_MANIFEST: 'manifest/generateBulk',
  MANIFEST_SEARCH_ORDERS: 'manifest/search_orders',
  BULK_ACTION_UPLOAD: 'finance/wd/bulkAction',
  DOWNLOAD_SAMPLE_FILE: 'order/Download_samples',
  GET_BULK_ACTION_STATUS: 'finance/wd/bulkActionStatus',
  GET_BULK_LABELS: 'tools/getBulkLabelsAndPdfZipComma',
  DELIVERY_DB_SEARCH: 'tools/generic/deliveryDB/search',
  DOWNLOAD_POD: 'tools/downloadPODs',
  PTL_PUR_SEARCH: 'b2b/pickup/search',
  MERCHANT_DETAILS: 'config/merchant',
  MANUAL_ALLOCATE_COURIER: 'b2b/pickup/allocate_courier',
  MERCHANT_SEARCH: 'merchant/search',
  MANUAL_CANCEL_COURIER: 'b2b/pickup/cancel_request',
  BULK_PTL_PUR: 'b2b/pickup/bulk_pickup_orders_B2B',
  BULK_UPLOAD_B2B_TRACK: 'b2b/tracking/v2/bulk_tracking_b2b_upload',
  GET_DELIVERY_LOCATIONS: 'merchant/delivery_location',
  ADD_DELIVERY_LOCATIONS: 'merchant/save_delivery_location',
  UPLOAD_DELIVERY_LOCATIONS: 'merchant/upload_delivery_location',
  UPDATE_NDR_EMAIL_CONFIG: 'reports/config/update',
  ADD_NDR_EMAIL_CONFIG: 'reports/config/add',
  GET_NDR_EMAIL_CONFIG: 'reports/config/get',
  WALLET_EMAIL_CONFIG: 'wallet/updateNotificationConfig',
  // Pickup drop mapping: drop (state / pincode) → pickup pincode, used by storefronts (e.g. Shopify) for EDD (proship_mongo /api/pickup-drop-mapping)
  PICKUP_DROP_MAPPING: 'pickup-drop-mapping',
  UPDATE_CUSTOMER_DETAILS: 'channel/order/updateCustomer',
  GENERATE_BULK_INVOICE: 'tools/generateBulkInvoice',
  GENERATE_BULK_INVOICE_LABEL_MERGE: 'tools/generateBulkLabelAndInvoice',
  GENERATE_BULK_LABELS: 'tools/generateBulkLabel',
  CREATE_FRESHDESK: 'freshdesk/create',
  FILTER_FRESHDESK: 'freshdesk/filter',
  CLOSE_FRESHDESK: 'freshdesk/close',
  GET_TICKETID_FRESHDESK: 'freshdesk/get',
  REPLY_FRESHDESK: 'freshdesk/reply',
  GET_FRESHDESK_STATUS_LIST: 'freshdesk/getStatusList',
  // Escalation Desk V2 — the in-house ticket backend (proship_mongo's escalation module)
  // replacing the freshdesk/* proxy above. All merchant-scoped: the backend auto-restricts
  // every call to the logged-in merchant's own tickets, so no merchantId is ever sent from here.
  // Same endpoint names as the admin panel (proship-backend) — same backend, same contract.
  ESCALATION_SEARCH_V2: 'escalation/search',
  ESCALATION_CREATE_V2: 'escalation/create',
  ESCALATION_STATUS_CONFIG_V2: 'escalation/config/statuses',
  ESCALATION_CATEGORY_CONFIG_V2: 'escalation/config/categories',
  // `${apiConstants.ESCALATION_DETAIL_V2}/${id}`, `.../${id}/remark`.
  ESCALATION_DETAIL_V2: 'escalation',
  ESCALATION_EXPORT_V2: 'escalation/export',
  ESCALATION_STATS_V2: 'escalation/stats',
  RVP_ORDER: 'returnOrder/returnWithFwdReference_unitwise',
  // The platform-wide category vocabulary — {enum, displayName} — already used to set a
  // merchant's own category in the admin panel. Reused for product categories so the two
  // agree rather than a second taxonomy growing up beside the first.
  GET_MERCHANT_CATEGORY: 'merchant/getMerchantCategories',
  MERCHANT_CATEGORY: 'QCCP/findAllCategory',
  MERCHANT_CATEGORY_QUES: 'QCCP/getQCByCategory',
  MERCHANT_CATEGORY_QUES_POST: 'config/addQCQuestionsMerchantByQCCode',
  MERCHANT_QC_LIST: 'config',
  COD_REMITTANCE_REPORT: 'cod/reportsMerged',
  COD_MERCHANT_REPORT: 'cod/filter/report',
  GENERIC_UPDATE: 'tools/generic/update',
  REFRESH_URL: 'tools/refresh/url',
  REFRESH_URL_S3: 'tools/refreshAnySignedUrl',
  REATTEMPT_NPR: 'order/nprActionUpdate',
  UPLOAD_SKU_IMAGE: 'product/uploadImageByReturn',
  // Product master: the sheet upsert is the only write path (keyed merchantId + skuCode), and
  // the image host returns a permanent URL that the sheet's image1..image10 columns then carry.
  UPLOAD_SKU_DETAILS: 'product/uploadSkuDetails',
  UPLOAD_IMAGE_NON_EXPIRE: '/tools/uploadImagesNonExpire',
  GET_RETURN_SHIPMENT_DETAILS: 'returnAndExchangeOrder/getReturnShipmentDetails',
  APPROVE_RETURN_REQUEST: 'returnAndExchangeOrder/returnOrExchange_unitwise',
  UPDATE_RETURN_REQUEST: 'returnAndExchangeOrder/updateReturnOrExchange_unitwise',
  REJECT_RETURN_REQUEST: 'returnAndExchangeOrder/sendRejectedMessage',
  ACCEPT_RETURN_REQUEST: 'returnAndExchangeOrder/sendReturnsAcceptedMessage',
  GET_RETURN_AWB: 'returnAndExchangeOrder/getReturnAwb',
  get_specific_data_delivery:
    'external/ct/controltower/v1/wms/freightsnapshot/getSpecificData/delivery',
  get_specific_data_pickup:
    'external/ct/controltower/v1/wms/freightsnapshot/getSpecificData/pickup',
  get_specific_data_rto_delivery:
    'external/ct/controltower/v1/wms/freightsnapshot/getSpecificData/rtoDelivery',
  get_ndr_analysis_data: 'external/ct/controltower/v1/wms/getNdrAnalysisData',
  REFRESH_S3_URL: 'tools/refreshS3Ref',
  NDR_RULEUPDATE: 'ndr/automatedRule/ruleUpdate',
  NDR_RULEDEACTIVATE: 'ndr/automatedRule/fileUpload',
  RETURN_EXCHANGE_ORDER_LIST: 'returnAndExchangeOrder/search',
  GENERATE_AUTH_TOKEN_FOR_PROSHIP: 'external/ct/controltower/api/auth/generateAuthTokenForProship',
  PROSHIP_PILOT_URL:
    'https://9p5xeeuyw9.execute-api.ap-south-1.amazonaws.com/Dev/proshipWithStreaming/',
  getSnapshotsNotUpdateLastNHours: `external/ct/controltower/v1/wms/freightsnapshot/getSnapshotsNotUpdateLastNHours`,
  GET_NOTIFICATIONS: 'ui/notification/search',
  VALIDATE_GOOGLE_AUTH_CODE: 'auth/validateMerchantToken',
  UPLOAD_NOTIFICATION_CONFIG: 'config/SavePushNotifConfigBulk',
  DELETE_NOTIFICATION_CONFIG: 'config/deleteEmailsGroupWrapper',
  TRACKING_MY_CONFIG: 'merchantDesc/config/tracking/myConfig',
  TRACKING_SAVE_BRANDING: 'merchantDesc/config/tracking/saveBranding',
  APPOINTMENT_DELIVERY: 'order/appointment_delivery',
  APPOINTMENT_DELIVERY_CLOSE: 'order/appointment_delivery/close',
  APPOINTMENT_DELIVERY_CONFIG: 'order/appointment_delivery/config',
  APPOINTMENT_DELIVERY_DASHBOARD: 'order/appointment_delivery/dashboard',
  APPOINTMENT_DELIVERY_EXPORT: 'order/appointment_delivery/export',
  APPOINTMENT_DELIVERY_CLOSURE_REASON: 'order/appointment_delivery/closure_reason',
  APPOINTMENT_DELIVERY_DOC_URL: 'order/appointment_delivery/doc_url',
  // Merchant-scoped PTL EDD breaches and PoD analytics (NabdMerchantController / PodMerchantController).
  PTL_EDD_BREACH_MERCHANT: 'merchant/ptl/edd-breach',
  POD_ANALYTICS_MERCHANT: 'merchant/pod/analytics',
  BUTL_UPLOAD_APPOINTMENT_MISS: 'tools/upload/bulk/abd_miss',
  // Additional Documents + Receiver Contact upload (non-appointment B2B shipments)
  ADDITIONAL_DOCUMENTS: 'order/additional_documents',
  ADDITIONAL_DOCUMENTS_DOC_URL: 'order/additional_documents/doc_url',
  RTO_CONFIG: 'order/rto/document-config',
  APPOINTMENT_DELIVERY_ADD_DOCS: 'order/appointment_delivery/add_documents',
  ADDITIONAL_DOCUMENTS_UPLOAD: 'order/additional_documents/upload',
  BUTL_UPLOAD_APPOINTMENT_DELIVERY: 'tools/upload/bulk/abd',
  GET_WEIGHT_DISCREPANCY_ANALYTICS: 'tools/getWeightDescDataCounts',
  EDIT_B2C_ORDER: 'order/edit_b2c_order',
  RESYNC_CHANNEL_ORDER: 'channel/order/resync',
  CANCEL_CHANNEL_ORDER: 'channel/order/cancel',
  CANCEL_CHANNEL_ORDER_ITEM: 'channel/order/cancel-item',
  CREATE_INSURANCE_PROPOSAL: 'insure/symbo/createProposal',
  FUTWORKS_CONFIG: 'config/futworksConfig',
  CHANNEL_ORDER_VERIFICATION: 'config/channelOrder/orderConfirmation',
  CHANNEL_ADDRESS_VERIFICATION: 'config/channelOrder/addressVerification',
  SYSTEM_DEFAULT_PRICING: 'config/getMerchantOnboardingTimeDefaultPricings',
  /*
    Tracking page branding. Taken verbatim from origin/dev alongside TrackingConfig.js so the
    two stay mergeable — same keys, same paths, no local spelling.
  */
  TRACKING_MY_CONFIG: 'merchantDesc/config/tracking/myConfig',
  TRACKING_SAVE_BRANDING: 'merchantDesc/config/tracking/saveBranding',
  MOBILE_LOGIN: 'auth/signin_otp',
  VALIDATE_OTP: 'auth/signin_validateotp',
  COMMUNICATION_CONFIG: 'config/merchant',
  COMMUNICATION_CONFIG_UPDATE: 'config/merchant/update',
  GET_MIS_FROM_AWB: 'order/readAwbFromExcelTest',
  SORTER_IMAGE_DOWNLOAD: 'tools/getBulkSorterImages',
  GET_DELIVERY_METRICS: 'external/ct/controltower/v1/wms/getDeliveryMetrics',
  GET_TAT_METRICS: 'external/ct/controltower/v1/wms/getTATMetrics',
  GET_RVP_PICKUP_METRICS: 'external/ct/controltower/v1/wms/getRVPPickupMetrics',
  MERCHANT_UPDATE: 'merchant/update',
  GET_OTP_CANCELLATION_DETAILS: 'order/getOtpCancellationDetails',
  PUSH_CHANNEL_ORDER_FULFILLMENT_TO_SHOPIFY: 'tools/pushChannelOrderFulfilmentToShopify',
  SET_MERCHANT_RULE: 'ruleengine/setMerchantRule',
  CREATE_MERCHANT_RULE: 'ruleengine/create_rule',
  TOGGLE_APPOINTMENT_DELIVERY: 'order/toggle_appointment_delivery',
  GET_UNIQUE_STORE_NAMES: 'channel/order/unique-store-names',
  UNHOLD_COD: 'channel/order/merchant',
  UPLOAD_REMARK: 'tools/upload/file',
  GET_PINCODES: 'order/getPickupAndDeliveryPincodes',
  CLONE_ORDER: 'order/createClone',
  CLONE_ORDER_WITH_EDIT: 'order/createCloneWithEdit',
  CREATE_PACKAGE: 'package_master/create_package',
  GET_PACKAGES: 'package_master/findByMerchantOid',
  UPDATE_PACKAGE: 'package_master/update_package',
  DELETE_PACKAGE: 'package_master/delete_package',
  MODIFY_SEND_OTP: 'modify/sendotp',
  MODIFY_PII_ACCESS: 'modify/piiaccess',
  MODIFY_MFA_ENABLE: 'modify/mfastatus',
  VALIDATE_MSAL_AUTH_CODE: 'auth/verify-microsoft-id-token',
  BULK_UPDATE_ADDRESS: 'channel/order/bulk-update-address',
  SEND_OTP_FOR_USER_MOBILE_NUMBER_UPDATE: 'modify/mobilenumber',
  MODIFY_UNMASKED_ADDRESS_ACCESS_UPDATE: 'modify/unmaskedAddressAccess',
  CLAIMS_TYPES: 'claims/claimTypes',
  CLAIMS_CHECK_ELIGIBILITY: 'claims/checkEligibility',
  CLAIMS_RAISE: 'claims/raise',
  CLAIMS_LIST: 'claims/list',
  CLAIMS_DETAIL: 'claims',
  CLAIMS_UPLOAD_EVIDENCE: 'claims/uploadEvidence',
  CLAIMS_CONFIG: 'claims/config',
  RELEASE_NOTES: 'release-notes/v1/notes',
  RELEASE_NOTES_UNREAD: 'release-notes/v1/unread-count',
  RELEASE_NOTES_SEEN: 'release-notes/v1/seen',
  GET_FAKE_NDR: 'external/ct/controltower/v1/wms/freightsnapshot/getFakeNDR',
}

// How many channel orders are fulfilled in parallel from the Channel Orders "New" tab.
// Capped at 6 deliberately: proship.prozo.com is served over HTTP/1.1, and browsers allow only
// 6 concurrent connections per origin — additional workers would just queue in the browser
// without any extra throughput. Raise this only after HTTP/2 is enabled on the load balancer.
export const CHANNEL_ORDER_BATCH_SIZE = 10

export const viewbyDDOptSelected = 'last_7_days'

export function getDashboardDateFilter(key = null) {
  const lastMonths = 5
  const today = new Date()
  const startOfThisMonth = startOfMonth(today)
  const dates = [
    /* {
            fromDate: formatDate(subDays(today, 15), 'yyyy-MM-dd'),
            toDate: formatDate(today, 'yyyy-MM-dd'),
            label: 'Last 15 Days',
            key: 'last_15_days'
        }, */

    {
      fromDate: formatDate(subDays(today, 7), 'yyyy-MM-dd'),
      toDate: formatDate(today, 'yyyy-MM-dd'),
      label: 'Last 7 Days',
      key: 'last_7_days',
    },
    {
      fromDate: formatDate(subDays(today, 30), 'yyyy-MM-dd'),
      toDate: formatDate(today, 'yyyy-MM-dd'),
      label: 'Last 30 Days',
      key: 'last_30_days',
    },
    {
      fromDate: formatDate(startOfThisMonth, 'yyyy-MM-dd'),
      toDate: formatDate(today, 'yyyy-MM-dd'),
      label: 'This Month',
      key: 'this_month',
    },
  ]

  for (let i = 1; i <= lastMonths; i++) {
    const stDate = startOfMonth(subMonths(startOfThisMonth, i))
    const enMonth = endOfMonth(stDate)
    dates.push({
      fromDate: formatDate(stDate, 'yyyy-MM-dd'),
      toDate: formatDate(enMonth, 'yyyy-MM-dd'),
      label: formatDate(stDate, 'MMM yyyy'),
      key: `last_${i}_month`,
    })
  }

  if (!key) return dates.find((d) => d.key === viewbyDDOptSelected)
  if (key === 'all') return dates
  return dates.find((d) => d.key === key)
}

export const razorPayID = process.env.REACT_APP_RAZORPAY_ID
// export const razorPayID = "rzp_live_RYluVDMxkii3jY";
export const viewbyDDOpt = [
  { optKey: 'last_15_days', optValue: 'Last 15 Days' },
  { optKey: 'last_1_month', optValue: 'Last 1 Month' },
  { optKey: 'last_3_month', optValue: 'Last 3 Months' },
  /* { "optKey": "last_6_month", "optValue": "Last 6 Months" } */
]

export function post(endpoint, data) {
  return axios.post(`${endpoint}`, data)
  // return axios.post(`${finalUrl}`, data);
}

export function postGeneric(endpoint, data, config = {}) {
  let finalUrl = `${apiConstants.BASE_LOCAL}${endpoint}`
  return axios.post(`${finalUrl}`, data, config)
}

export function deleteGeneric(endpoint, data) {
  let finalUrl = `${apiConstants.BASE_LOCAL}${endpoint}`
  return axios.delete(`${finalUrl}`, data)
}

export function downloadZip(endpoint, data) {
  let finalUrl = `${apiConstants.BASE_LOCAL}${endpoint}`
  const config = {
    responseType: 'blob',
  }
  return axios.post(`${finalUrl}`, data, config)
}

export function getGeneric(endpoint, params = {}, requestParams = {}) {
  const searchParams = new URLSearchParams(params)
  for (const k of Object.keys(params)) {
    searchParams.set(k, params[k])
  }

  let finalUrl = `${apiConstants.BASE_LOCAL}${endpoint}`
  if (Object.keys(params).length > 0) {
    finalUrl += `?${searchParams.toString()}`
  }

  return axios.get(finalUrl, requestParams)
}

// Authenticated GET + blob response, for CSV/file endpoints (e.g. the coverage-by-zone
// and coverage-by-pincode downloads) — a plain <a href> download can't carry the
// Authorization header these routes require. Mirrors downloadZip's blob handling, GET-side.
export function getGenericBlob(endpoint, params = {}) {
  const searchParams = new URLSearchParams(params)
  for (const k of Object.keys(params)) {
    searchParams.set(k, params[k])
  }

  let finalUrl = `${apiConstants.BASE_LOCAL}${endpoint}`
  if (Object.keys(params).length > 0) {
    finalUrl += `?${searchParams.toString()}`
  }

  return axios.get(finalUrl, { responseType: 'blob' })
}

export function get(endpoint) {
  const finalUrl = `${endpoint}`
  return axios.get(finalUrl)
}

export function patch(endpoint, data) {
  return axios.patch(`${endpoint}`, data)
}

export function putGeneric(endpoint, data) {
  const finalUrl = `${apiConstants.BASE_LOCAL}${endpoint}`
  return axios.put(`${finalUrl}`, data)
}

export function postMultipart(endpoint, data) {
  let finalUrl = `${apiConstants.BASE_LOCAL}${endpoint}`
  return axios.post(finalUrl, data, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
}

export function getConcurrent(endpoints) {
  return axios.all(endpoints.map((endpoint) => axios.get(endpoint)))
}

export function getDownload(endpoint) {
  return axios.get(`${endpoint}`, {
    headers: {
      responseType: 'blob',
    },
  })
}

export function postDownload(endpoint, data) {
  return axios.post(`${endpoint}`, data, {
    headers: {
      responseType: 'blob',
    },
  })
}

export function getExcel(endpoint, params = {}, requestParams = {}) {
  const searchParams = new URLSearchParams(params)
  for (const k of Object.keys(params)) {
    searchParams.set(k, params[k])
  }

  let finalUrl = `${apiConstants.BASE_LOCAL}${endpoint}`
  if (Object.keys(params).length > 0) {
    finalUrl += `?${searchParams.toString()}`
  }

  return axios.get(finalUrl, requestParams)
}

const RETRY_LIMIT = 30
export const wait = (ms) => new Promise((resolve) => setTimeout(resolve, ms))

export async function sendMessage(message, threadId, ctToken) {
  let messageResponse = null

  try {
    const requestPayload = { message, thread_id: threadId }
    const poolData = await makeChatBotCall(requestPayload, ctToken)
    let currentIteration = 0

    while (currentIteration <= RETRY_LIMIT) {
      try {
        const apiResponse = await makeChatBotCall(poolData, ctToken)
        if (apiResponse?.success && apiResponse?.status === 'completed') {
          messageResponse = apiResponse
          break
        }

        await wait(3000)
        currentIteration++
      } catch (error) {
        console.error(`Error during fetching poll: ${error.message}`)
        throw error
      }
    }
  } catch (e) {
    console.error(`Unexpected error: ${e.message}`)
    throw e
  }

  if (messageResponse === null) {
    throw new Error('Unable to fetch message response!')
  }

  return messageResponse
}

const forProshipPilotAxios = axios.create()

export async function makeChatBotCall(payload, ctToken) {
  let responseData = null

  try {
    let endpoint = `${apiConstants.PROSHIP_PILOT_URL}addMessage`

    try {
      const apiResponse = await forProshipPilotAxios.post(endpoint, payload, {
        headers: {
          Authorization: `Bearer ${ctToken}`,
          'x-proship-token': `${localStorage.getItem('userToken')}`,
        },
      })

      if (apiResponse.status === 200) {
        responseData = apiResponse.data
      }
    } catch (error) {
      console.error(`Error during API call: ${error.message}`)
      throw error
    }
  } catch (e) {
    // Log or handle the error appropriately
    console.error(`Unexpected error: ${e.message}`)
    throw e
  }

  return responseData
}

export async function setAutoMerchantName(payload, ctToken) {
  const messageResponse = await makeChatBotCall(payload, ctToken)
  let lastIndex = messageResponse?.last_index
  let isPoll = messageResponse.poll
  let isStatus = messageResponse.status
  let iteration = 0

  while (isPoll && isStatus === 'in_progress' && iteration <= 30) {
    const pollPayload = {
      poll: true,
      thread_id: messageResponse.thread_id,
      run_id: messageResponse.run_id,
      last_index: lastIndex,
    }
    const response = await makeChatBotCall(pollPayload, ctToken)
    isPoll = response.poll
    isStatus = response.status
    if (response.message && response.last_index > 0) {
      lastIndex = response.last_index
    }
    iteration++
    await wait(1000)
  }

  return messageResponse
}
